import { isB2BMode } from '../../../utils/b2bUtils';
import { sendInteractionEvent } from '../../utils';

const getServiceEventAction = (service: string): string => {
    switch (service) {
        case 'coop_offers':
            return 'Min Coop-butik';
        case 'xtra_offers':
            return 'X:-tra butiker';
        case 'member_association':
            return 'Min konsumentförening';
        case 'membership_program':
            return 'Coops medlemsprogram';
        case 'sms':
            return 'Erbjudanden via SMS';
        case 'other':
            return 'Personliga annonser';
        default:
            return service;
    }
};

const subscribe = (service: string) => {
    sendInteractionEvent({
        eventCategory: 'Mina sidor',
        eventAction: getServiceEventAction(service),
        eventLabel: 'På',
    });
};

const unsubscribe = (service: string) => {
    sendInteractionEvent({
        eventCategory: 'Mina sidor',
        eventAction: getServiceEventAction(service),
        eventLabel: 'Av',
    });
};

const subscribeToWeeklyNewsletter = (page: string, storeName?: string) => {
    sendInteractionEvent({
        eventCategory: page,
        eventAction: 'Inskickad E-postadress DR',
        eventLabel: storeName,
        customerSegment: isB2BMode() ? 'Företag' : 'Privat',
    });
};

export default {
    subscribe,
    unsubscribe,
    subscribeToWeeklyNewsletter,
};
